import { API_BASE_URL } from "../../constants";
import HttpInterface from "../../helpers/HttpInterface";
import { defaultFetchParam, FetchParam } from "../../Models/FetchParam";
import { buildAPIUrl } from "../../api/apiHelpers";

export default class KpiService {
  private httpProxy: HttpInterface;

  constructor() {
    this.httpProxy = new HttpInterface();
  }

  getStatistic(params: FetchParam = defaultFetchParam): Promise<any> {
    const requestOptions = {
      method: "GET",
    };

    return this.httpProxy.fetch(
      buildAPIUrl(
        `${API_BASE_URL}/registry-service/feedbacks/kpi/statistics`,
        params
      ),
      requestOptions
    );
  }
}
